/* nori-wa-offer.js — the WhatsApp welcome offer popup (Dawn 15.x).
   Config comes from window.NORI_WA, written by sections/nori-wa-offer.liquid.
   Everything runs inside one try/catch: a failure here can never touch the rest
   of the page. No dependencies. */
(function () {
  "use strict";
  try {
    var C = window.NORI_WA;
    if (!C) return;
    var root = document.getElementById("nori-wa");
    if (!root) return;

    var STATE_KEY = "nori_wa";
    var PV_KEY = "nori_wa_pv";
    var APPLIED_KEY = "nori_wa_applied";
    var SHOWN_KEY = "nori_wa_shown";
    var DAY = 864e5;

    /* ---- storage ------------------------------------------------------------ */
    function loadState() {
      try { return JSON.parse(localStorage.getItem(STATE_KEY) || "null"); } catch (e) { return null; }
    }
    function saveState(s) {
      try { localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
    }
    function sessionGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function sessionSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    /* ---- events: server log + GTM dataLayer ---------------------------------- */
    function track(type, extra) {
      try { (window.dataLayer = window.dataLayer || []).push({ event: "nori_wa_" + type }); } catch (e) {}
      if (!C.apiBase) return;
      var body = JSON.stringify(Object.assign({ event: type, mode: C.mode, template: C.template }, extra || {}));
      /* text/plain keeps this a "simple" request: no preflight, no credentials,
         so it survives page unloads. The server parses the JSON regardless. */
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(C.apiBase + "/v1/events", new Blob([body], { type: "text/plain" }));
        } else {
          fetch(C.apiBase + "/v1/events", { method: "POST", headers: { "Content-Type": "text/plain" }, body: body, keepalive: true }).catch(function () {});
        }
      } catch (e) {}
    }

    /* ---- apply the code to the cart (Shopify's discount link sets a cookie the
       cart picks up on its next touch; verified to reach the GoKwik checkout) --- */
    function applyCode(code) {
      if (!code) return;
      if (sessionGet(APPLIED_KEY) === code) return;
      fetch("/discount/" + encodeURIComponent(code) + "?redirect=/", { credentials: "same-origin" })
        .then(function () { sessionSet(APPLIED_KEY, code); track("applied"); })
        .catch(function () {});
    }

    /* ---- should it show at all? ------------------------------------------------ */
    var qs = new URLSearchParams(location.search);
    var force = qs.get("nori_wa") === "show";
    if (qs.get("nori_wa") === "off") return;

    var state = loadState();
    if (state && state.code) applyCode(state.code); /* a verified browser keeps its code on the cart */

    if (!force) {
      if (state && state.status === "dismissed" && Date.now() - state.at < C.dismissDays * DAY) return;
      if (state && (state.status === "issued" || state.status === "existing") && Date.now() - state.at < C.verifiedDays * DAY) return;
      if (sessionGet(SHOWN_KEY)) return; /* once per session, even if it was never closed (reload, back button) */
    }

    /* page-view counter for the second-page trigger */
    var pv = parseInt(sessionGet(PV_KEY) || "0", 10) + 1;
    sessionSet(PV_KEY, String(pv));
    var onHome = C.template === "index";
    if (!force && !C.designMode) {
      if (C.mode === "home_only" && !onHome) return;
      if (C.mode === "home_or_second_page" && !onHome && pv < 2) return;
      /* all_pages: no template gate — the Liquid already skips cart/password/gift card */
    }

    /* the cart lives on the home page URL (KwikCart redirects /cart → /?openCart=true):
       never cover the shopper's cart or an open checkout */
    function visible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 200 && r.height > 200;
    }
    function cartBusy() {
      if (qs.get("openCart") === "true") return true;
      if (document.getElementById("gokwik-iframe")) return true;            /* GoKwik checkout modal */
      if (document.querySelector("cart-drawer.active")) return true;        /* Dawn's own drawer */
      /* KwikCart's drawer lives in the shadow root of <shadow-dom-container>: .overlay + .sidecart (400px wide) */
      var host = document.querySelector("shadow-dom-container");
      if (host && host.shadowRoot && (visible(host.shadowRoot.querySelector(".sidecart")) || visible(host.shadowRoot.querySelector(".overlay")))) return true;
      var els = document.querySelectorAll('[id*="kwikcart" i], [class*="kwikcart" i], [id*="gokwik" i]');
      for (var i = 0; i < els.length; i++) if (visible(els[i])) return true;
      return false;
    }

    /* ---- elements ------------------------------------------------------------- */
    var $ = function (sel) { return root.querySelector(sel); };
    var panel = $(".nori-wa__panel");
    var screens = { phone: $('[data-nw-screen="phone"]'), otp: $('[data-nw-screen="otp"]'), done: $('[data-nw-screen="done"]') };
    var phoneInput = $("[data-nw-phone]");
    var hp = $("[data-nw-hp]");
    var optin = $("[data-nw-optin]");
    var err = $("[data-nw-error]");
    var submitBtn = $("[data-nw-submit]");
    var otpInput = $("[data-nw-otp]");
    var otpErr = $("[data-nw-otp-error]");
    var verifyBtn = $("[data-nw-verify]");
    var resendBtn = $("[data-nw-resend]");
    var timerEl = $("[data-nw-timer]");
    var sentTo = $("[data-nw-sent-to]");
    var doneTitle = $("[data-nw-done-title]");
    var doneBody = $("[data-nw-done-body]");
    var codeEl = $("[data-nw-code]");
    var copyBtn = $("[data-nw-copy]");
    var appliedLine = $("[data-nw-applied]");

    var challengeId = null;
    var pendingDigits = "";
    var pendingOptIn = false;
    var timer = null;
    var opened = false;
    var lastFocus = null;

    function show(name) {
      for (var k in screens) if (screens[k]) screens[k].hidden = k !== name;
      var first = screens[name] && (screens[name].querySelector("input:not([type=hidden]):not(.nori-wa__hp):not([type=checkbox])") || screens[name].querySelector("button"));
      if (first) setTimeout(function () { first.focus(); }, 30);
    }
    function setErr(el, msg) { el.textContent = msg || ""; el.hidden = !msg; }
    function busy(btn, on, label) {
      btn.disabled = on;
      if (on) { btn.setAttribute("data-nw-label", btn.textContent); btn.textContent = label; }
      else if (btn.getAttribute("data-nw-label")) { btn.textContent = btn.getAttribute("data-nw-label"); }
    }

    function open(trigger) {
      if (opened) return;
      if (document.documentElement.classList.contains("nori-wa-lock")) return; /* another nori popup is open */
      if (!force && !C.designMode && cartBusy()) return;
      opened = true;
      if (!force && !C.designMode) sessionSet(SHOWN_KEY, "1");
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add("nori-wa-lock");
      show("phone");
      track("shown", { trigger: trigger });
    }
    function close(reason) {
      root.hidden = true;
      document.documentElement.classList.remove("nori-wa-lock");
      if (reason === "dismissed") {
        saveState({ status: "dismissed", at: Date.now() });
        track("dismissed");
      }
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }

    /* ---- API ------------------------------------------------------------------- */
    function api(path, payload) {
      return fetch(C.apiBase + path, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
      }).then(function (r) {
        return r.text().then(function (t) {
          var body = null;
          try { body = t ? JSON.parse(t) : null; } catch (e) {}
          return { status: r.status, body: body || {} };
        });
      });
    }
    function minutes(s) { return Math.max(1, Math.ceil((s || 60) / 60)); }
    function errorText(res, fallback) {
      var e = res.body && res.body.error;
      if (e === "invalid_phone") return C.copy.errInvalid;
      if (e === "rate_limited") return C.copy.errRate.replace("{m}", minutes(res.body.retry_after_s));
      if (e === "delivery_failed") return C.copy.errDelivery;
      if (e === "expired") return C.copy.errExpired;
      if (e === "too_many_attempts") return C.copy.errTooMany;
      if (e === "wrong_otp") return C.copy.errWrong.replace("{n}", res.body.attempts_left);
      return fallback || C.copy.errGeneric;
    }

    function startTimer(seconds) {
      var until = Date.now() + seconds * 1000;
      resendBtn.disabled = true;
      if (timer) clearInterval(timer);
      function tick() {
        var left = Math.max(0, Math.round((until - Date.now()) / 1000));
        if (left <= 0) { clearInterval(timer); timerEl.textContent = ""; resendBtn.disabled = false; return; }
        timerEl.textContent = "(" + left + "s)";
      }
      tick();
      timer = setInterval(tick, 1000);
    }

    function finish(status, code) {
      var existing = status === "existing";
      doneTitle.textContent = existing ? C.copy.existingTitle : C.copy.successTitle;
      doneBody.textContent = existing ? C.copy.existingBody : C.copy.successBody;
      codeEl.textContent = code;
      copyBtn.textContent = C.copy.copyLabel;
      saveState({ status: status, at: Date.now(), code: code });
      applyCode(code);
      show("done");
    }

    function sendCode() {
      var digits = (phoneInput.value || "").replace(/\D/g, "");
      if (digits.length === 12 && digits.indexOf("91") === 0) digits = digits.slice(2);
      if (digits.length === 11 && digits.charAt(0) === "0") digits = digits.slice(1);
      if (!/^[6-9]\d{9}$/.test(digits)) { setErr(err, C.copy.errInvalid); phoneInput.focus(); return; }
      setErr(err, "");
      pendingDigits = digits;
      pendingOptIn = Boolean(optin && optin.checked);
      busy(submitBtn, true, C.copy.sending);
      api("/v1/otp/send", { phone: digits, marketing_opt_in: pendingOptIn, hp: hp ? hp.value : "" })
        .then(function (res) {
          if (res.status === 200 && res.body.status === "sent") {
            challengeId = res.body.challenge_id;
            sentTo.textContent = res.body.phone_masked || ("+91 " + digits);
            otpInput.value = "";
            setErr(otpErr, "");
            startTimer(res.body.resend_after_s || 30);
            track("number_typed", { cid: challengeId });
            show("otp");
          } else if (res.status === 200 && res.body.status === "existing") {
            finish("existing", res.body.code || C.code);
          } else if (res.status === 503) {
            close("quiet"); /* switched off server-side: never show an error the shopper did not cause */
          } else {
            setErr(err, errorText(res));
          }
        })
        .catch(function () { setErr(err, C.copy.errGeneric); })
        .then(function () { busy(submitBtn, false); });
    }

    function verifyCode() {
      var code = (otpInput.value || "").replace(/\D/g, "");
      if (code.length !== 6) { setErr(otpErr, C.copy.errWrong.replace("{n}", "")); otpInput.focus(); return; }
      setErr(otpErr, "");
      busy(verifyBtn, true, C.copy.verifying);
      api("/v1/otp/verify", { challenge_id: challengeId, otp: code })
        .then(function (res) {
          if (res.status === 200 && res.body.status === "issued") {
            finish("issued", res.body.code || C.code);
          } else {
            setErr(otpErr, errorText(res));
            if (res.status === 410 || res.status === 429) resendBtn.disabled = false;
          }
        })
        .catch(function () { setErr(otpErr, C.copy.errGeneric); })
        .then(function () { busy(verifyBtn, false); });
    }

    /* ---- wiring ------------------------------------------------------------------ */
    screens.phone.addEventListener("submit", function (e) { e.preventDefault(); sendCode(); });
    screens.otp.addEventListener("submit", function (e) { e.preventDefault(); verifyCode(); });
    $("[data-nw-back]").addEventListener("click", function () { if (timer) clearInterval(timer); show("phone"); });
    resendBtn.addEventListener("click", function () {
      if (resendBtn.disabled) return;
      resendBtn.disabled = true;
      api("/v1/otp/send", { phone: pendingDigits, marketing_opt_in: pendingOptIn, hp: "" }).then(function (res) {
        if (res.status === 200 && res.body.status === "sent") {
          challengeId = res.body.challenge_id;
          otpInput.value = "";
          setErr(otpErr, "");
          startTimer(res.body.resend_after_s || 30);
        } else if (res.status === 200 && res.body.status === "existing") {
          finish("existing", res.body.code || C.code);
        } else {
          setErr(otpErr, errorText(res));
          resendBtn.disabled = false;
        }
      }).catch(function () { setErr(otpErr, C.copy.errGeneric); resendBtn.disabled = false; });
    });
    otpInput.addEventListener("input", function () {
      var v = otpInput.value.replace(/\D/g, "").slice(0, 6);
      if (v !== otpInput.value) otpInput.value = v;
      if (v.length === 6) verifyCode();
    });
    copyBtn.addEventListener("click", function () {
      var code = codeEl.textContent;
      var done = function () { copyBtn.textContent = C.copy.copied; track("copied"); setTimeout(function () { copyBtn.textContent = C.copy.copyLabel; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else { var r = document.createRange(); r.selectNodeContents(codeEl); var s = getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand("copy"); } catch (e) {} done(); }
    });
    $("[data-nw-done]").addEventListener("click", function () { close("done"); });
    $("[data-nw-close]").addEventListener("click", function () { close(screens.done.hidden ? "dismissed" : "done"); });
    $("[data-nw-backdrop]").addEventListener("click", function () { close(screens.done.hidden ? "dismissed" : "done"); });
    document.addEventListener("keydown", function (e) {
      if (root.hidden) return;
      if (e.key === "Escape") { close(screens.done.hidden ? "dismissed" : "done"); return; }
      if (e.key === "Tab") { /* keep focus inside the dialog */
        var f = panel.querySelectorAll("button:not([disabled]), input:not([disabled]):not(.nori-wa__hp), [href]");
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ---- triggers ------------------------------------------------------------- */
    if (C.designMode) {
      /* theme editor: show only when the merchant selects this section */
      document.addEventListener("shopify:section:select", function (e) { if (e.detail && e.detail.sectionId === C.sectionId) { opened = false; open("editor"); } });
      document.addEventListener("shopify:section:deselect", function (e) { if (e.detail && e.detail.sectionId === C.sectionId) close("editor"); });
      return;
    }
    if (force) { open("forced"); return; }

    function arm() {
      /* the popup will very likely show now: fetch the hero during the delay so it
         never appears blank (it stays lazy for visitors who never get this far) */
      var hero = root.querySelector(".nori-wa__hero img");
      if (hero) hero.loading = "eager";
      if (C.delayMs >= 0) setTimeout(function () { open("delay"); }, C.delayMs);
      if (C.scrollPct > 0) {
        var onScroll = function () {
          var doc = document.documentElement;
          var max = doc.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          if ((window.scrollY / max) * 100 >= C.scrollPct) { window.removeEventListener("scroll", onScroll); open("scroll"); }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
      }
    }
    if (document.readyState === "complete") arm();
    else window.addEventListener("load", arm);
  } catch (e) {
    try { console.warn("nori-wa-offer:", e); } catch (_) {}
  }
})();
